import React from 'react';
import __ from 'lodash';

class DropdownKelas extends React.Component{
    render(){
        return (
            this.props.kelas.map((val) =>
                <option key={val.idKelas} value={val.idKelas}>{val.namaKelas}</option>
            )            
        )
    }
}

export default DropdownKelas;